import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TapAndPlayIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tap_and_play"}/>
}
